import type { TextBlock } from '../../../interfaces/textEditor.interface';

interface TextBlockInput {
  id: string;
  type: string | undefined;
  data: TextBlockDataInput;
  __typename?: string;
}

interface TextBlockDataInput {
  paragraph: string | null;
  header: string | null;
  level: number | null;
  items: string[] | null;
  file: TextBlockDataFileInput | null;
  code: string | null;
  withBorder: boolean | null;
  withBackground: boolean | null;
  stretched: boolean | null;
  caption: string | null;
  style: string | null;
}

interface TextBlockDataFileInput {
  originalName: string;
  size: number;
  type: string;
  url: string;
}

/**
 * Formats a given TextBlock object into a TextBlockInput object suitable for GraphQL.
 *
 * @param {TextBlock} block - The input text block containing id, type, and data attributes.
 * @returns {TextBlockInput} - The formatted text block with structured data attributes.
 */
export const formatBlockForGraphQL = (block: TextBlock): TextBlockInput => {
  const { id, type, data } = block;
  return {
    id,
    type,
    data: {
      caption: data?.caption || null,
      code: data?.code || null,
      file: data?.file || null,
      header: data?.header || null,
      // @ts-ignore
      items: data.items || null,
      level: data?.level || null,
      paragraph: data?.paragraph || null,
      stretched: data?.stretched || null,
      style: data?.style || null,
      withBackground: data?.withBackground || null,
      withBorder: data?.withBorder || null,
    },
  };
};
